import { HttpClient } from "@/App/services";
import config from "@/App/config";
import { version, name } from "../../../../../package.json";
const baseUrl = config.API_URL;
export const FeedbackService = {
  addFeedback(feedback: string): Promise<object> {
    return HttpClient.post({
      path: `v4/feedback`,
      rewriteBaseUrlWith: baseUrl,
      data: {
        message: feedback,
        clientInfo: {
          client: name,
          clientVersion: version
        }
      }
    });
  }
};
